module.exports = __webpack_public_path__ + "img/game1.28babc2d.png";